import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export interface FAQItem {
  q: string;
  a: string;
}

interface HoursParkingFAQProps {
  faqs: FAQItem[];
  intro?: string;
}

const HoursParkingFAQ = ({
  faqs,
  intro = "Open daily — reopened Spring 2026.",
}: HoursParkingFAQProps) => {
  return (
    <section
      id="faq"
      style={{ scrollMarginTop: "96px" }}
      className="scroll-mt-24 py-16 md:py-20"
    >
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="text-center mb-8">
          <h2 className="font-serif text-3xl md:text-4xl text-foreground mb-3">
            Hours, Parking &amp; FAQ
          </h2>
          <p className="text-muted-foreground">{intro}</p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`}>
              <AccordionTrigger className="text-left">{f.q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default HoursParkingFAQ;